<template>
	<router-link to="/notice-detail/171" class="banner_sub">
		<img src="@/assets/img/etf/etf.jpg" class="banner_content_img" loading="lazy" alt="banner_etf" />
	</router-link>
</template>

<script setup lang="ts"></script>
<style lang="scss" scoped>
.banner_sub {
	border-radius: 0.8rem;
	background: rgba(241, 233, 237, 0.98);
	height: 14rem;
	display: flex;
	align-items: center;
	overflow: hidden;
	position: relative;
	@media screen and (max-width: 1280px) {
		height: 8.2rem;
	}
	.banner_content_img {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}
}
</style>
